import { RequestHeaders } from './utilities';
export function UserCommands(api) {
    return {
        profile: () => api.authenticated().get(`User/GetProfile`, {}, RequestHeaders),
    };
}
//# sourceMappingURL=userCommands.js.map